import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosClient from '../api/axiosClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('fish_shop_user');
    const token = localStorage.getItem('fish_shop_token');

    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem('fish_shop_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (credentials) => {
    const res = await axiosClient.post('/auth/login', credentials);
    if (res.success && res.token) {
      localStorage.setItem('fish_shop_token', res.token);
      localStorage.setItem('fish_shop_user', JSON.stringify(res.user));
      localStorage.setItem('fish_shop_firm_id', res.user.firmId);
      localStorage.setItem('fish_shop_fid', res.user.fid);
      if (res.user.tenantId) localStorage.setItem('fish_shop_tenant_id', res.user.tenantId);
      if (res.user.tenantDb) localStorage.setItem('fish_shop_tenant_db', res.user.tenantDb);
      setUser(res.user);
      return res;
    }
    throw new Error(res.message || 'Login failed.');
  };

  const logout = () => {
    localStorage.removeItem('fish_shop_token');
    localStorage.removeItem('fish_shop_user');
    localStorage.removeItem('fish_shop_firm_id');
    localStorage.removeItem('fish_shop_fid');
    setUser(null);
  };

  const switchTenant = (tenant) => {
    if (tenant) {
      localStorage.setItem('fish_shop_tenant_id', tenant.id || tenant.slug);
      localStorage.setItem('fish_shop_tenant_db', tenant.database);
      logout();
      window.location.href = '/login';
    }
  };

  const switchFirm = (newFirmId, newFirmName) => {
    if (user) {
      const updatedUser = { ...user, firmId: newFirmId, firmName: newFirmName };
      localStorage.setItem('fish_shop_firm_id', newFirmId);
      localStorage.setItem('fish_shop_user', JSON.stringify(updatedUser));
      setUser(updatedUser);
    }
  };

  const switchFid = (newFid, newFYear) => {
    if (user) {
      const updatedUser = { ...user, fid: newFid, fYear: newFYear };
      localStorage.setItem('fish_shop_fid', newFid);
      localStorage.setItem('fish_shop_user', JSON.stringify(updatedUser));
      setUser(updatedUser);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        switchTenant,
        switchFirm,
        switchFid,
        isAuthenticated: !!user
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
